// frontend/src/components/admin/Sidebar.jsx
import React, { useEffect, useState } from 'react';
import { 
  LayoutDashboard, 
  Users, 
  FileText, 
  Settings,
  BarChart3,
  History,
  Calendar,
  Package,
  CreditCard,
  HelpCircle,
  BookOpen,
  UploadCloud,
  BarChart,
  FolderOpen,
  LogOut,
  ShieldCheck,
  FileSignature
} from 'lucide-react';
import { useNavigate, Link, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const menuItems = [
    { 
      icon: LayoutDashboard, 
      label: 'Dashboard', 
      path: '/admin/' 
    },
    { 
      icon: Users, 
      label: 'Users',
      path: '/admin/users' 
    },
    { icon: History, label: 'Login History', path: '/admin/user/login-history' },
    { icon: BookOpen, label: 'Blogs', path: '/admin/upload-blog' },
    { icon: FileText, label: 'Upload Logo', path: '/admin/upload-logo' },
    { icon: BarChart, label: 'Page Metadata', path: '/admin/page-metadata' },
    { icon: UploadCloud, label: 'Upload Document', path: '/admin/upload-pdf' },
    { icon: Package, label: 'Purchase History', path: '/admin/doc-purchase-history' },
    { icon: BarChart3, label: 'Content Update', path: '/admin/content-update' },
    { icon: FolderOpen, label: 'Portfolio Content', path: '/admin/portfolio' },
    { icon: FileSignature, label: 'Terms & Conditions', path: '/admin/terms' },
    { icon: ShieldCheck, label: 'Policies', path: '/admin/policies' },
    // { icon: Package, label: 'Products', path: '#' },
    // { icon: CreditCard, label: 'Transactions', path: '#' },
    // { icon: BarChart3, label: 'Analytics', path: '#' },
    // { icon: Calendar, label: 'Calendar', path: '#' },
    // { icon: Settings, label: 'Settings', path: '#' },
  ];

  // Check if a menu item is active based on current route
  const isActive = (itemPath) => {
    // Exact match for dashboard
    if (itemPath === '/admin/' && location.pathname === '/admin/') {
      return true;
    }
    // For users, check if current path starts with the menu path
    if (itemPath !== '/admin/' && location.pathname.startsWith(itemPath)) {
      return true;
    }
    return false;
  };

  // Check if user is logged in
  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  // Simple version with confirmation
  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      localStorage.clear();
      window.location.href = '/admin/login';
    }
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={() => {}}
        />
      )}
      
      <aside className={`
        fixed lg:fixed inset-y-0 left-0 z-30
        w-64 bg-gray-900 dark:bg-gray-800
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0
        h-screen
        flex flex-col
      `}>
        {/* Logo */}
        <div className="flex-shrink-0 flex items-center justify-center h-16 border-b border-gray-800 px-4">
          <Link to="/admin/" className="flex items-center space-x-3">
            <div className="h-8 w-8 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
              <LayoutDashboard className="h-5 w-5 text-white" />
            </div>
            <span className="text-xl font-bold text-white">MarketMaestroo</span>
          </Link>
        </div>

        {/* Navigation - Scrollable area */}
        <div className="flex-1 overflow-y-auto py-4">
          <nav className="px-4">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">
              Main Menu
            </p>
            <ul className="space-y-2">
              {menuItems.map((item, index) => (
                <li key={index}>
                  {item.path === '#' ? (
                    <a
                      href="#"
                      className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-colors ${
                        isActive(item.path)
                          ? 'bg-blue-600 text-white'
                          : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                      }`}
                    >
                      <item.icon className="h-5 w-5" />
                      <span className="font-medium">{item.label}</span>
                    </a>
                  ) : (
                    <Link
                      to={item.path}
                      className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-colors ${
                        isActive(item.path)
                          ? 'bg-blue-600 text-white'
                          : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                      }`}
                    >
                      <item.icon className="h-5 w-5" />
                      <span className="font-medium">{item.label}</span>
                    </Link>
                  )}
                </li>
              ))}
            </ul>

            {/* Support Section */}
            <div className="mt-8">
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">
                Actions
              </p>
              <ul className="space-y-2">
                
                <li>
                  <a
                    href="#"
                    className="flex items-center space-x-3 px-3 py-2.5 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors"
                    onClick={handleLogout}
                  >
                    <LogOut className="h-5 w-5" />
                    <span className="font-medium">Logout</span>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;